import { BaseContainerModel } from "../base-container.model";
export class EntityCreditUtilizationModel extends BaseContainerModel {
    entity_hdr_guid: number;
    entity_name: number;
    credit_limit: number;
    gendoc_open_balance: number;
    open_queue_balance: number;
}

